import { t } from '../../../../../shared/i18n';
import React from 'react';
import { Modal, Typography, message } from 'antd';
import domainRegistrationService from '../../../../services/domainRegistrationService';

const { Text } = Typography;

/**
 * 获取转移码并弹窗展示（可复制）。域名锁定时先提示解锁。
 */
export const showAuthCode = async (domain) => {
    if (!domain) return;
    if (domain.privacy?.enabled) {
        message.warning(t('Turn off privacy mode before transferring out'));
        return;
    }
    if (domain.domain_lock) {
        message.warning(t('Please unlock the domain first'));
        return;
    }
    try {
        const r = await domainRegistrationService.getAuthCode(domain.id);
        if (r.success && r.emailed) {
            Modal.success({
                title: t('Transfer code · {{value}}', { value: domain.domain_unicode || domain.domain }),
                content: t('The auth code has been sent to the domain\'s administrative contact email'),
                okText: t('Close'),
            });
            return;
        }
        if (!r.success || !r.auth_code) {
            message.error(r.error || t('Failed to retrieve transfer code'));
            return;
        }
        Modal.info({
            title: t('Transfer code · {{value}}', { value: domain.domain_unicode || domain.domain }),
            icon: null,
            content: React.createElement(
                Text,
                { code: true, copyable: true, style: { fontSize: 16, wordBreak: 'break-all' } },
                r.auth_code
            ),
            okText: t('Close'),
        });
    } catch (e) {
        message.error(e.code === 'privacy_mode_on' ? t('Turn off privacy mode before transferring out') : (e.error || e.message || t('Failed to retrieve transfer code')));
    }
};

export default showAuthCode;
